import { email, phone } from '@/components/site-layout';
import { LegalPageLayout } from './legal-layout';

export default function LegalNoticePage() {
  return (
    <LegalPageLayout
      title="Mentions légales"
      description="Informations relatives à l’éditeur, à la publication et à l’hébergement du site SHER CLEAN."
    >
      <section>
        <h2>Éditeur du site</h2>
        <address>
          <strong>SHER SOLUTIONS — enseigne SHER CLEAN</strong>
          <br />
          Semra Handan ER, entrepreneur individuel
          <br />
          6 rue du Commandant Pierre Mulsant
          <br />
          10000 Troyes, France
          <br />
          SIREN : 952 088 607
          <br />
          SIRET : 952 088 607 00025
          <br />
          Email : <a href={`mailto:${email}`}>{email}</a>
          <br />
          Téléphone : <a href="tel:+33628730551">{phone}</a>
        </address>
        <p style={{ marginTop: 12 }}>
          Responsable de la publication : Semra Handan ER.
        </p>
      </section>

      <section>
        <h2>Hébergement du site</h2>
        <p>
          Hébergeur : <strong>IONOS</strong>
        </p>
      </section>
    </LegalPageLayout>
  );
}
